import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import List from 'components/Common/List'

type Props = {
  maximumRoomCapacities: Array<string>
}

function AccommodationMaximumRoomCapacities({ maximumRoomCapacities }: Props) {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: '_VYJWxjzFF0zQLXVBjmV',
    defaultMessage: 'Maximum room capacity',
    description: 'Heading for the maximum room capacity section within the guest policy area of the room details modal.',
  })

  return (
    <>
      <Heading variant="heading6" as="h4">{heading}</Heading>
      <List>
        {maximumRoomCapacities.map((capacity) => (
          <BodyText key={capacity} as="li" variant="medium">
            {capacity}
          </BodyText>
        ))}
      </List>
    </>
  )
}

export default AccommodationMaximumRoomCapacities
